import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardElementFrame from '../CardElementFrame';
import { getCardTemplateSizing } from '../AccountCard/helpers';

const propTypes = {
  className: PropTypes.string,
  cardTemplate: PropTypes.shape({
    id: PropTypes.string.isRequired,
    print_size: PropTypes.shape({
      id: PropTypes.string.isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }),
    card_elements: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        frame: PropTypes.object.isRequired,
        type: PropTypes.string,
      }).isRequired,
    ).isRequired,
  }).isRequired,
};

const CardTemplatePreview = ({ className, cardTemplate }) => {
  const classes = classNames({
    'card-template-preview': true,
    [className]: !!className,
  });
  const { ratio } = getCardTemplateSizing(cardTemplate);

  return (
    <div className={classes} style={{ paddingBottom: `${ratio * 100}%` }}>
      {cardTemplate.card_elements.map(cardElement => {
        return (
          <CardElementFrame key={cardElement.id} element={{ cardElement }} />
        );
      })}
    </div>
  );
};

CardTemplatePreview.propTypes = propTypes;

export default CardTemplatePreview;
